import React from 'react';
import styled from 'styled-components';
import cdnPath from 'shared/utils/cdnPath';
import { DynamicAction, DynamicActionKey } from 'shared/utils/DynamicAction/DynamicAction';
import { GAME_TRIGGERS } from 'shared/constants/types';
import { TEXT_KEY, getText } from 'shared/utils/localization';
import Button from '../../../../components/Button/Button';
import { BUTTON_STROKES } from 'shared/utils/buttonTextStrokes';

const GameIconsGrid = ({ gameIds, navigation }) => {
  if (!gameIds || gameIds.length === 0) return null;

  const handlePlayClick = gameId => {
    DynamicAction.getActionCallback(`${DynamicActionKey.LAUNCH_GAME}:${gameId}:${GAME_TRIGGERS.EVENTS}`, navigation)();
  };

  return (
    <Container>
      {gameIds.map(gameId => (
        <GameIconWrapper key={gameId}>
          <GameIcon src={`${cdnPath.SLOT_ICON_MOBILE}/${gameId}.png`} alt={`Game ${gameId}`} />
          <Button
            textStroke={BUTTON_STROKES.PRIMARY}
            label={getText(TEXT_KEY.PLAY_BUTTON)}
            onClick={() => handlePlayClick(gameId)}
            containerStyle={buttonContainerStyle}
            imageStyle={buttonImageStyle}
            textStyle={buttonTextStyle}
          />
        </GameIconWrapper>
      ))}
    </Container>
  );
};

export default GameIconsGrid;

const Container = styled.div`
  display: flex;
  padding-left: 0.5rem;
  padding-right: 1.5rem;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  gap: 2.5vw;
  align-items: flex-start;
`;

const GameIconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const GameIcon = styled.img`
  width: 14vh;
  height: 14vh;
  object-fit: cover;
`;

const buttonContainerStyle = `
  width: 13vh;
  margin-top: -0.5vh;
`;

const buttonImageStyle = `
  width: 13vh;
  height: 4vh;
`;

const buttonTextStyle = `
  font-size: 2.5vh;
`;
